module.exports = __webpack_public_path__ + "static/media/img.filter1.87312d99.svg";